<template>
  <div class="root">
    <b-container fluid>
      <b-row class="p-1">
        <b-col></b-col>
        <b-col md="6">
          <b-card variant="light" class="p-1 logwrap">
            <div v-if="ongoing" class="alert alert-info p-3">
              You Have an unfinished Test, which will resume in
              {{ countdown }}secs
            </div>
            <div
              v-if="error"
              class="alert alert-danger alert-dismissible p-3"
              v-html="errmsg"
            ></div>

            <div class="welc">
              <h3>Welcome!</h3>
              <h4>Login to Start Test</h4>
            </div>
            <form @submit.prevent="logUser">
              <b-form-group label="Email : " label-for="email">
                <b-form-input
                  v-model="login.email"
                  type="email"
                  id="email"
                  class="loginp p-3"
                  placeholder="user@example.com"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-form-group label="Password" label-for="password">
                <b-form-input
                  v-model="login.password"
                  type="password"
                  id="password"
                  class="loginp p-3"
                  placeholder="*********"
                  required
                  @focus="setErr"
                >
                </b-form-input>
              </b-form-group>

              <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-overlay
                    :show="logginin"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="logginin"
                      type="submit"
                      class="btn-md p-1 w-100"
                      variant="warning"
                      >Login</b-button
                    >
                  </b-overlay>
                </b-col>
                <b-col md="3"></b-col>
              </b-row>

              <div class="welc p-4">
                New to us? <a href="https://quicktestng.com/signup"> Sign up</a>
                <p class="welc p-4">
                  <a href="https://quicktestng.com/forgot">Forgot password</a>
                </p>
              </div>
            </form>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//import NProgress from "nprogress";

export default {
  data() {
    return {
      login: this.createLogin(),
      countdown: 5,
      logginin: false,
      frompath : ""
    };
  },
  beforeRouteEnter(to, from, next) {
    // NProgress.start();
    //alert(from.name)
    
    //alert(from.fullPath)
    next()
    //NProgress.done();
  },
  created() {
      //this.$router.push(this.frompath)
      let now = new Date();
      now.setFullYear(now.getFullYear() - 10)
      document.cookie = `remember=;expires=${now.toUTCString()}`
      document.cookie = `qid=;expires=${now.toUTCString()}`
      
      if (this.loggedin) {
        this.$router.push({
          name: "landing",
          params: {
            fullname: this.details.fullname,
          },
        });
      }
      
  },

  updated() {
    if (this.ongoing) {
      setTimeout(() => {
        this.countdown = this.countdown - 1;
        if (this.countdown == 0) {
          this.movedown();
        }
      }, 1000);
    }
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      ongoing: (state) => state.ongoing,
      start_config: (state) => state.exam.start_config,
      error: (state) => state.loginmaster.error,
      errmsg: (state) => state.loginmaster.errmsg,
    }),
  },
  methods: {
    logUser() {
      this.setloader();

      //NProgress.start();
      return this.$store
        .dispatch("loginmaster/sendLogin", this.login)
        .then(() => {
          //NProgress.done()
          if (this.error) {
            this.logginin = false;
          }

          if (this.loggedin && !this.ongoing) {
            this.$router.push({
              name: "landing",
              params: {
                fullname: this.details.fullname,
              },
            });
          }
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk("Check your Network Connection. Could not Log in.", {
              title: "No Network Connection",
              size: "xs",
              centered: true,
            })
            .then(() => {
              this.logginin = false;
            });
          //console.log(error);
        });
    },
    movedown() {
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
        },
      });
    },
    createLogin() {
      return {
        email: "",
        password: "",
      };
    },
    setloader() {
      this.logginin = true;
    },
    ...mapActions("loginmaster", ["setErr"]),
  },
};
</script>

<style scoped>

.logwrap {
  box-shadow: 5px 5px 15px grey;
}

.welc {
  text-align: center;
  font-size: 1.3rem
}

p {
  text-align: left;
  font-size: 16px;
  padding: 5px;
}

.inpdiv {
  padding: 10px;
}

.sign-up {
  text-align: center;
  margin-top: 2rem;
}

.loginput {
  width: 300px;
  padding: 10px;
}

.btn-md {
  font-size: 18px;
  font-weight: bold;
  color: #263056;
  cursor: pointer;
}

.logimg {
  width: 100%;
  height: 60vh;
}
</style>
